import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { Container } from 'reactstrap';
import { useAuth } from '../../helpers/hooks';

interface MenuItem {
  id: string;
  label: string;
  icon: string;
  link: string;
  roles?: string[];
}

const menuItems: MenuItem[] = [
  { id: 'dashboard', label: 'Ana Ekran', icon: 'ri-dashboard-2-line', link: '/dashboard' },
  { id: 'waybills', label: 'İrsaliyeler', icon: 'ri-file-list-3-line', link: '/waybills' },
  { id: 'daily-records', label: 'Günlük Kayıtlar', icon: 'ri-calendar-check-line', link: '/daily-records' },
  { id: 'projects', label: 'Projeler', icon: 'ri-building-4-line', link: '/projects' },
  { id: 'sites', label: 'Şantiyeler', icon: 'ri-building-line', link: '/sites' },
  { id: 'vehicles', label: 'Araçlar', icon: 'ri-truck-line', link: '/vehicles', roles: ['ADMIN'] },
  { id: 'fuel', label: 'Yakıt', icon: 'ri-gas-station-line', link: '/fuel', roles: ['ADMIN'] },
  { id: 'personnel', label: 'Personel', icon: 'ri-team-line', link: '/personnel', roles: ['ADMIN'] },
  { id: 'payroll', label: 'Hakediş', icon: 'ri-money-dollar-circle-line', link: '/payroll', roles: ['ADMIN', 'MUHASEBE'] },
  { id: 'personnel-leave', label: 'İzin Takip', icon: 'ri-calendar-close-line', link: '/personnel-leave', roles: ['ADMIN', 'MUHASEBE'] },
  { id: 'work-types', label: 'İş Türleri', icon: 'ri-tools-line', link: '/work-types', roles: ['ADMIN'] },
  { id: 'users', label: 'Kullanıcılar', icon: 'ri-user-settings-line', link: '/users', roles: ['ADMIN'] },
  { id: 'settings', label: 'Ayarlar', icon: 'ri-settings-3-line', link: '/settings' },
];

const Sidebar: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  const userRole = user?.role?.name;

  // Close sidebar on mobile when clicking overlay
  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName('vertical-overlay');
    if (verticalOverlay && verticalOverlay[0]) {
      verticalOverlay[0].addEventListener('click', function () {
        document.body.classList.remove('vertical-sidebar-enable');
      });
    }
  }, []);

  const filteredMenuItems = menuItems.filter((item) => {
    if (!item.roles) return true;
    return item.roles.includes(userRole || '');
  });

  const handleMenuClick = () => {
    if (window.innerWidth < 992) {
      document.body.classList.remove('vertical-sidebar-enable');
    }
  };

  return (
    <>
      <div className="app-menu navbar-menu">
        {/* Logo */}
        <div className="navbar-brand-box">
          <Link to="/" className="logo">
            <span className="logo-sm">A</span>
            <span className="logo-lg">ALKAYOL</span>
          </Link>
        </div>

        <SimpleBar id="scrollbar" className="h-100">
          <Container fluid>
            <ul className="navbar-nav" id="navbar-nav">
              <li className="menu-title">
                <span>Menü</span>
                <i className="ri-more-2-fill"></i>
              </li>

              {filteredMenuItems.map((item) => (
                <li className="nav-item" key={item.id}>
                  <Link
                    to={item.link}
                    className={`nav-link menu-link ${location.pathname === item.link || location.pathname.startsWith(item.link + '/') ? 'active' : ''}`}
                    onClick={handleMenuClick}
                  >
                    <i className={item.icon}></i>
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </Container>
        </SimpleBar>

        <div className="sidebar-background"></div>
      </div>
      <div className="vertical-overlay"></div>
    </>
  );
};

export default Sidebar;
